import { userActions } from "../../actionTypes";

const initialState = {
	success: false,
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.USER_UPDATE_FETCHING: {
			return { ...initialState, fetching: true };
		}

		case userActions.USER_UPDATE_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				success: action.payload,
			};
		}

		case userActions.RESET_UPDATE_STATE: {
			return { ...state, ...initialState };
		}

		case userActions.USER_UPDATE_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
